import { LocalizedText, lt } from '@mews/framework';
import { TextKey, SearchType } from '@mews-commander/enums';
import { Stack } from '@optimus-web/core';
import { DateIntervalFields, EnumSelectField, SelectField } from '@mews-commander/form';
import { AvailabilityBlockStates, Service } from '@mews-commander/data-access';
import { SearchHookField } from '../../../components/form/hookFields';
import { FilterValueKey } from '../constants';
import { mapServiceToOption } from '../utils';

export const AvailabilityBlockReportFilterFields = ({ services }: { services: Array<Service> }) => (
    <Stack vertical spacing="300">
        <DateIntervalFields
            mode="utc"
            startDateProps={{ name: FilterValueKey.startDate, label: lt(TextKey.Start), required: true }}
            endDateProps={{ name: FilterValueKey.endDate, label: lt(TextKey.End), required: true }}
        />
        <SelectField
            name={FilterValueKey.serviceId}
            label={lt(TextKey.Service)}
            options={services.length ? services.map(mapServiceToOption) : []}
        />
        <EnumSelectField
            multiselect
            name={FilterValueKey.states}
            label={lt(TextKey.Status)}
            enumClass={AvailabilityBlockStates}
            enumPrefix="AvailabilityBlockStates"
            compact
        />
        <SearchHookField
            name={FilterValueKey.companyId}
            searchTypes={[SearchType.Company]}
            label={<LocalizedText textKey={TextKey.SearchForCompany} />}
            placeholder={<LocalizedText textKey={TextKey.SearchByName} />}
        />
        <SearchHookField
            name={FilterValueKey.travelAgencyId}
            searchTypes={[SearchType.TravelAgency]}
            label={<LocalizedText textKey={TextKey.TravelAgency} />}
            placeholder={<LocalizedText textKey={TextKey.SearchByName} />}
        />
    </Stack>
);
